import { FC, useEffect } from "react";
import "../styles/LoadingAnim.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import userImage from "../../../assets/images/defaultAvatar.png";
import { useAppSelector } from "../../../hooks/store.hooks";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { Button } from "../../../components/Button";

const EditPageButtonLink: FC<{ categoryId: any; cell: any }> = ({
  categoryId,
  cell,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log('categoryId', categoryId)
  console.log('cell', cell)

  const breadcrumbHandle = async (categoryId: any, cell: any) => {
    const data: any = [
      {
        label: "Categories",
        link: `/categories`,
      },
      {
        label: cell?.values?.name ? cell?.values?.name : cell?.value?.sku,
        link: `/categories/${categoryId}`,
      },
    ];
    // const data: any = {};
    store.dispatch(addBreadcrumb(data));
    navigate(`/categories/edit/${categoryId}`);
  };

  return (
    <Button
      onClick={() => breadcrumbHandle(categoryId, cell)}
      apparence="success"
      view="default"
      type="submit"
      size="md"
    >
      <div className="font-normal text-base">Edit</div>
    </Button>
  );
};

export default EditPageButtonLink;
